import { render, staticRenderFns } from "./PersonalWorks.vue?vue&type=template&id=16041dac&scoped=true"
import script from "./PersonalWorks.vue?vue&type=script&lang=js"
export * from "./PersonalWorks.vue?vue&type=script&lang=js"
import style0 from "./PersonalWorks.vue?vue&type=style&index=0&id=16041dac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16041dac",
  null
  
)

export default component.exports